export const selectPrompt = state => {
  const returnValue = state.prompt || {};
  return returnValue;
};
